import { useEffect } from "react";
import { useTheme } from "./contexts/NewThemeContext";

export default function TitleUpdater() {
  const { platformName, phrase } = useTheme() || {};

  useEffect(() => {
    if (platformName && platformName !== "null") {
      document.title = platformName;
    }
  }, [platformName]);

  useEffect(() => {
    if (phrase && phrase !== "null") {
      let metaDesc = document.querySelector("meta[name='description']");
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.name = "description";
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = phrase;
    }
  }, [phrase]);

  return null;
}
